import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, Fonts } from "../../coldcompute";

/** YouTube thumbnail (1280×720). One focal subject + bold 3–4 words, high contrast. */
export const MeasureDontGuessRagThumb: React.FC = () => (
  <AbsoluteFill
    style={{
      background: `radial-gradient(90% 90% at 76% 18%, #161007 0%, ${COLORS.bg} 56%, ${COLORS.bg2} 100%)`,
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      padding: "0 84px",
    }}
  >
    <Fonts />
    {/* faint scanline grain */}
    <AbsoluteFill
      style={{
        opacity: 0.06,
        mixBlendMode: "screen",
        backgroundImage: "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 3px)",
      }}
    />
    {/* giant focal number — the 41 seconds that hurt */}
    <div
      style={{
        position: "absolute",
        right: 50,
        top: 70,
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize: 300,
        lineHeight: 1,
        color: COLORS.red,
        opacity: 0.18,
      }}
    >
      41s
    </div>
    {/* status tag */}
    <div
      style={{
        fontFamily: FONTS.mono,
        fontSize: 28,
        letterSpacing: "0.2em",
        textTransform: "uppercase",
        color: COLORS.cyan,
        marginBottom: 18,
        border: `1px solid ${COLORS.cyan}`,
        borderRadius: 6,
        padding: "6px 14px",
      }}
    >
      ▍eval &gt; vibes
    </div>
    <div
      style={{
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize: 156,
        lineHeight: 0.9,
        letterSpacing: "-0.02em",
        color: COLORS.text,
      }}
    >
      STOP
      <br />
      <span style={{ color: COLORS.amber }}>GUESSING</span>
    </div>
    <div
      style={{
        fontFamily: FONTS.mono,
        fontSize: 26,
        color: COLORS.dim,
        marginTop: 26,
      }}
    >
      my RAG spent <span style={{ color: COLORS.red }}>41s</span> doubting itself ·{" "}
      <span style={{ color: COLORS.cyan }}>I let evals tune it</span>
    </div>
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
